import { render, staticRenderFns } from "./FlashMessages.vue?vue&type=template&id=38f5db65&scoped=true&"
import script from "./FlashMessages.vue?vue&type=script&lang=js&"
export * from "./FlashMessages.vue?vue&type=script&lang=js&"
import style0 from "./FlashMessages.vue?vue&type=style&index=0&id=38f5db65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5db65",
  null
  
)

export default component.exports